<footer class="main-footer">
  <div class="container-dynamic d-flex">
    Copyright 2023
  </div>
</footer>
